<template>
  <v-flex sm12 md12 lg12 v-if="message">
    <v-snackbar
      :value="snackbar"
      :color="message.httpStatus == 200 ? 'green' : 'red'"
      :timeout="message.httpStatus == 200 ? 2000 : 0"
      :vertical="false"
    >
      {{message.message}}
      <v-btn dark flat @click="clear">Close</v-btn>
    </v-snackbar>
  </v-flex>
</template>
<script>
import { mapActions, createNamespacedHelpers } from "vuex";
import { mapMessageFields } from "@/store/modules/forms/message";
const { mapActions: mapMessageActions } = createNamespacedHelpers(`message`);
export default {
  name: "MessageAlert",
  data() {
    return {
      hide: false
    };
  },

  computed: {
    ...mapMessageFields(["message"]),
    snackbar: function() {
      if (this.hide) return false;
      if (this.message.httpStatus !== 0) return true;
    },
    submitted: function() {
      if (this.message.httpStatus === 200) {
        return "success";
      } else return "error";
    }
  },
  methods: {
    ...mapMessageActions(["reset"]),
    clear() {
      this.reset();
    }
  }
};
</script>
